
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 68","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M20.5 58.546L15 64.02l-5.5-5.474c-.667-.663-1.667-.663-2.333 0-.667.664-.667 1.659 0 2.322l6.666 6.634c.334.332.75.498 1.167.498s.833-.166 1.167-.498l6.666-6.634c.667-.663.667-1.658 0-2.322-.666-.663-1.666-.663-2.333 0z"}}),_c('path',{attrs:{"d":"M22.833 49.424c-.666-.663-1.666-.663-2.333 0L15 54.898l-5.5-5.474c-.667-.663-1.667-.663-2.333 0-.667.664-.667 1.659 0 2.322l6.666 6.634c.334.332.75.498 1.167.498s.833-.166 1.167-.498l6.666-6.634c.667-.663.667-1.658 0-2.322zM30 29.854V14.927C30 6.717 23.25 0 15 0S0 6.717 0 14.927v14.927c0 8.21 6.75 14.926 15 14.926s15-6.717 15-14.926zm-15 11.61c-6.417 0-11.667-5.225-11.667-11.61V14.927c0-6.386 5.25-11.61 11.667-11.61s11.667 5.224 11.667 11.61v14.927c0 6.385-5.25 11.61-11.667 11.61z"}}),_c('path',{attrs:{"d":"M15 9.122c-.917 0-1.667.746-1.667 1.658v4.976a1.668 1.668 0 003.334 0V10.78c0-.912-.75-1.658-1.667-1.658z"}})])])
          )
        }
      }
    